// extracted by mini-css-extract-plugin
export default {"actionBtn":"Update_actionBtn__nXkdB","confirm":"Update_confirm__qvWAv","reject":"Update_reject__z4v6b","buttonContainer":"Update_buttonContainer__bG4AH"};